var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import IconContainer from "./IconContainer";
const AdminNoteIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (React.createElement(IconContainer, Object.assign({ className: classNames("gerudo-icon-admin-note", size, className) }, props),
        React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("title", null, title),
            React.createElement("path", { d: "M11 1.5V4.2C11 5.88016 11 6.72024 11.327 7.36197C11.6146 7.92646 12.0735 8.3854 12.638 8.67302C13.2798 9 14.1198 9 15.8 9H18.5M19 10.9882V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H9.01178C9.74555 1 10.1124 1 10.4577 1.08289C10.7638 1.15638 11.0564 1.27759 11.3249 1.44208C11.6276 1.6276 11.887 1.88703 12.4059 2.40589L17.5941 7.59411C18.113 8.11297 18.3724 8.3724 18.5579 8.67515C18.7224 8.94356 18.8436 9.2362 18.9171 9.5423C19 9.88757 19 10.2545 19 10.9882Z", stroke: "currentColor", strokeWidth: "2" }))));
};
AdminNoteIcon.defaultProps = {
    title: "Administrative note",
};
export default AdminNoteIcon;
export { AdminNoteIcon };
//# sourceMappingURL=AdminNote.js.map